import gql from "graphql-tag";

export const ALL_WAREHOUSES = gql`
    query ALL_WAREHOUSES($page: Int!, $perPage: Int!, $isActive: Boolean = null){
        warehouses (page: $page, perPage: $perPage, isActive: $isActive) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                warehouseId,
                managerId,
                name,
                lat,
                longi,
                description,
                isActive,
                publicId,
            }
        }
    }
`;

export const SINGLE_WAREHOUSE = gql`
    query SINGLE_WAREHOUSE($id: String!){
        warehouse (id: $id) {
            warehouseId,
            managerId,
            name,
            lat,
            longi,
            description,
            isActive,
            publicId,
            stock {
                publicId,
                productId {
                    publicId,
                    productName,
                    code
                    shipmentsPaginated (withStock: true) {
                        objects {
                            publicId,
                            orderId,
                        }
                    }
                },
                warehouseId{
                    name,
                    publicId
                }
                quantity,
                quantityCase,
                quantityBall,
                quantityPiece
            },
        }
    }
`;

export const ADD_NEW_WAREHOUSE = gql`
    mutation ADD_NEW_WAREHOUSE($description: String!, $lat: String!, $longi: String!, $name: String!, $isDefaultWarehouse: Boolean){
        warehouse(description: $description, lat: $lat, longi: $longi, name:$name ,isDefaultWarehouse: $isDefaultWarehouse) {
            warehouse {
                warehouseId,
                name,
                publicId
            }
        }
    }
`;

export const UPDATE_WAREHOUSE = gql`
    mutation UPDATE_WAREHOUSE($id: ID!, $description: String!, $lat: String!, $longi: String!, $name: String!, $isDefaultWarehouse: Boolean ){
        warehouse(id: $id, description: $description, lat: $lat, longi: $longi, name:$name ,isDefaultWarehouse: $isDefaultWarehouse) {
            warehouse {
                warehouseId,
                name,
                publicId
            }
        }
    }
`;

export const WAREHOUSE_TOGGLE_STATUS = gql`
    mutation WAREHOUSE_TOGGLE_STATUS($id: ID!) {
        warehouseToggleStatus(id: $id) {
            warehouse {
                publicId,
                name,
                warehouseId,
            }
        }
    }
`;

// SHIPMENTS

export const ALL_SHIPMENTS = gql`
    query ALL_SHIPMENTS($page: Int!, $perPage: Int!, $searchKeyword: String){
        shipments (page: $page, perPage: $perPage, searchKeyword: $searchKeyword) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                orderId,
                productId {
                    publicId,
                    code
                    productName
                },
                expiryDate,
                warehouseId {
                    publicId,
                    name
                },
                quantity,
                initialStockQuantity,
                newStockQuantity,
                orderPrice,
                dateOrdered,
                expiryDate,
                lastUpdatedBy {
                    publicId,
                    name
                }
            }
        }
    }
`;

export const ADD_NEW_SHIPMENT = gql`
    mutation ADD_NEW_SHIPMENT($orderId: String!, $productId: String!, $warehouseId: String!, $quantity: Float!, $orderPrice: Float!, $dateOrdered: Date!, $expiryDate: Date!){
        shipment(orderId: $orderId, productId: $productId, warehouseId:$warehouseId , quantity:$quantity, orderPrice:$orderPrice, dateOrdered: $dateOrdered, expiryDate:$expiryDate) {
            shipment {
                publicId,
                shipmentId
            }
        }
    }
`;

export const UPDATE_SHIPMENT = gql`
    mutation UPDATE_SHIPMENT($id: ID!, $orderId: String!, $productId: String!, $warehouseId: String!, $quantity: Float!, $orderPrice: Float!, $dateOrdered: Date!, $expiryDate: Date!){
        shipment(id: $id, orderId: $orderId, productId: $productId, warehouseId:$warehouseId , quantity:$quantity, orderPrice:$orderPrice, dateOrdered: $dateOrdered, expiryDate:$expiryDate) {
            shipment {
                publicId,
                shipmentId
            }
        }
    }
`;

// STOCK ADJUSTMENT

export const ALL_STOCK_ADJUSTMENTS = gql`
    query ALL_STOCK_ADJUSTMENTS($page: Int!, $perPage: Int!, $searchKeyword: String){
        stockAdjustments (page: $page, perPage: $perPage, searchKeyword: $searchKeyword) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                productId {
                    publicId,
                    productName,
                    code
                },
                shipment {
                    publicId,
                    orderId
                },
                warehouseId {
                    publicId,
                    name
                },
                quantity,
                description
                initialStockQuantity,
                newStockQuantity,
                createdAt,
                lastUpdatedBy {
                    publicId,
                    name
                }
            }
        }
    }
`;

export const UPDATE_ADJUSTED_STOCK = gql`
    mutation UPDATE_ADJUSTED_STOCK($productId: String!, $shipmentId: String!, $adjustmentType: String, $quantity: Float!, $dateOrdered: Date!, $description: String!){
        stockAdjustment(productId: $productId, shipmentId: $shipmentId, adjustmentType: $adjustmentType,  quantity: $quantity, dateOrdered: $dateOrdered, description: $description){
            stockAdjustment {
                publicId
            }
        }
    }
`;

export const MOVE_STOCK = gql`
    mutation MOVE_STOCK($shipmentId: String!, $quantity: Int!, $targetWarehouseId: String!){
        moveStock(shipmentId: $shipmentId,  quantity: $quantity, targetWarehouseId: $targetWarehouseId){
            message
        }
    }
`;

export const STOCK_ADJUSTMENT_OPERATIONS = gql`
    query STOCK_ADJUSTMENT_OPERATIONS{
        stockAdjustmentOperations{
            id,
            name
        }
    }
`;


// STOCK

export const ALL_STOCK = gql`
    query ALL_STOCK($page: Int, $perPage: Int, $searchKeyword: String) {
        stocks(page: $page, perPage: $perPage, searchKeyword: $searchKeyword) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                publicId,
                productId {
                    publicId,
                    productName,
                    code,
                    shipments {
                        publicId,
                        orderId,
                    }
                    shipmentsPaginated (withStock: true) {
                        objects {
                            publicId,
                            orderId,
                            warehouseId {
                                publicId,
                                name
                            },
                        }
                    }
                },
                warehouseId{
                    name,
                    publicId
                }
                quantity,
                quantityCase,
                quantityBall,
                quantityPiece
            }
        }
    }
`;

// PRODUCTS

export const ALL_PRODUCTS = gql`
    query ALL_PRODUCTS($page: Int, $perPage: Int, $searchKeyword: String) {
        products(page: $page, perPage: $perPage, searchKeyword: $searchKeyword) {
            total
            previousPage
            pages
            page
            hasNext
            hasPrevious
            nextPage
            objects {
                publicId,
                productName,
                officialProductName,
                thumbnail
                abbreviation,
                code,
                jancode,
                itfcode,
                quantityPerCase,
                m3,
                caseWeight,
                bowlWeight,
                unitWeight,
                volume,
                qpoUnit,
                minimumOrderUnit,
                expiryPeriod,
                launchedDate,
                pricing,
                availableForOrder,
                description,
                shipments {
                    publicId,
                    orderId,
                    stockBalance,
                    quantity,
                    initialStockQuantity,
                    newStockQuantity,
                    createdAt
                },
                shipmentsPaginated (page: 1, perPage: 30, searchKeyword: "", showDeleted: false, withStock: false) {
                    page,
                    total,
                    objects {
                        publicId,
                        orderId,
                        stockBalance,
                        quantity,
                        initialStockQuantity,
                        newStockQuantity,
                        createdAt
                    }
                }
            }
        }
    }
`;

export const ALL_PRODUCTS_SIMPLE = gql`
    query ALL_PRODUCTS_SIMPLE($page: Int, $perPage: Int, $searchKeyword: String, $shipmentSearchKeyword: String, $excludeUnavailableForOrder: Boolean) {
        products(page: $page, perPage: $perPage, searchKeyword: $searchKeyword, excludeUnavailableForOrder: $excludeUnavailableForOrder) {
            total
            previousPage
            pages
            page
            hasNext
            hasPrevious
            nextPage
            objects {
                publicId,
                productName,
                officialProductName,
                abbreviation,
                shipmentsPaginated (page: 1, perPage: 30, searchKeyword: $shipmentSearchKeyword, showDeleted: false, withStock: true) {
                    page,
                    total,
                    objects {
                        publicId,
                        orderId,
                        expiryDate,
                        warehouseId {
                            publicId,
                            name
                        },
                        stockBalance,
                        quantity,
                        initialStockQuantity,
                        newStockQuantity,
                        createdAt
                    }
                },
                shipments {
                    publicId,
                    orderId,
                    expiryDate,
                    warehouseId {
                        publicId,
                        name
                    },
                    stockBalance,
                    quantity,
                    initialStockQuantity,
                    newStockQuantity,
                    createdAt
                }
            }
        }
    }
`;

export const SINGLE_PRODUCT = gql`
    query SINGLE_PRODUCT($id: String!, $shipmentCurrentPage: Int, $shipmentSearchKeyword: String, $ordersCurrentPage: Int, $orderSearchKeyword: String) {
        product(id: $id) {
            publicId,
            productName,
            officialProductName,
            thumbnail
            abbreviation,
            code,
            jancode,
            itfcode,
            quantityPerCase,
            m3,
            caseWeight,
            bowlWeight,
            unitWeight,
            volume,
            qpoUnit,
            minimumOrderUnit,
            expiryPeriod,
            launchedDate,
            pricing,
            availableForOrder,
            description,
            shipmentsPaginated (page: $shipmentCurrentPage, perPage: 30, searchKeyword: $shipmentSearchKeyword, showDeleted: false, withStock: false) {
                page,
                pages
                total,
                objects {
                    publicId,
                    orderId,
                    stockBalance,
                    quantity,
                    initialStockQuantity,
                    newStockQuantity,
                    createdAt,
                    expiryDate,
                    orderPrice
                }
            }
            ordersPaginated (page: $ordersCurrentPage, perPage: 30, searchKeyword: $orderSearchKeyword, showDeleted: false, customers: [], status: [], payment: [], deliveryDates: [], isFuture: false) {
                page,
                total,
                objects {
                    publicId
                    invoiceId,
                    customer {
                        publicId,
                        name
                    }
                    createdAt
                    orderedBy
                    deliveryDate
                    grossOrderTotal
                    status {
                        publicId,
                        orderStatusName
                    },
                }
            }
        }
    }
`;

export const ADD_NEW_PRODUCT = gql`
    mutation ADD_NEW_PRODUCT($officialProductName: String!, $productName: String!,$code: String!, $abbreviation: String,$itfcode: String!, $jancode: String!, $m3: String!,
        $quantityPerCase: Float, $caseWeight: String, $bowlWeight: String, $unitWeight: String, $volume: String!, $expiryPeriod: Int!,  $minimumOrderUnit: String!,
        $launchDate: Date, $description: String, $qpoUnit: Int,
        $pricing: GenericScalar, $availableForOrder: Boolean) {
        product(code: $code, expiryPeriod: $expiryPeriod, itfcode: $itfcode, jancode: $jancode, m3: $m3, minimumOrderUnit: $minimumOrderUnit,
            officialProductName: $officialProductName, productName: $productName, volume: $volume, unitWeight: $unitWeight,quantityPerCase: $quantityPerCase,
            qpoUnit: $qpoUnit, pricing: $pricing, availableForOrder: $availableForOrder, launchDate: $launchDate,description: $description, caseWeight: $caseWeight, bowlWeight: $bowlWeight, abbreviation: $abbreviation) {
            product {
                publicId
                productName
            }
        }
    }
`;

export const UPDATE_PRODUCT = gql`
    mutation ADD_NEW_PRODUCT($id: ID, $officialProductName: String!, $productName: String!,$code: String!, $abbreviation: String,$itfcode: String!, $jancode: String!, $m3: String!,
        $quantityPerCase: Float, $caseWeight: String, $bowlWeight: String, $unitWeight: String, $volume: String!, $expiryPeriod: Int!,  $minimumOrderUnit: String!,
        $launchDate: Date, $description: String, $qpoUnit: Int,
        $pricing: GenericScalar, $availableForOrder: Boolean) {
        product(id: $id, code: $code, expiryPeriod: $expiryPeriod, itfcode: $itfcode, jancode: $jancode, m3: $m3, minimumOrderUnit: $minimumOrderUnit,
            officialProductName: $officialProductName, productName: $productName, volume: $volume, unitWeight: $unitWeight,quantityPerCase: $quantityPerCase,
            qpoUnit: $qpoUnit, pricing: $pricing, availableForOrder: $availableForOrder, launchDate: $launchDate,description: $description, caseWeight: $caseWeight, bowlWeight: $bowlWeight, abbreviation: $abbreviation) {
            product {
                publicId
                productName
            }
        }
    }
`;

export const ALL_PRODUCTS_ORDER_UNITS = gql`
    query ALL_PRODUCTS_ORDER_UNITS {
        productOrderUnits {
            id,
            name
        }
    }
`;
